import React, { Component } from "react";
import _ from "lodash";
import { Card, CardBody, Col, Row } from "reactstrap";
import Fade from "react-reveal/Fade";
import { withNamespaces } from "react-i18next";
import Loader from "../../../Global/Loader";
import { Button } from "reactstrap";
import Table from "../../Components/Table";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services.js";
import { Icon } from "semantic-ui-react";
import { Modal, message, Transfer } from "antd";
import {
  Autocomplete,
  TextField,
  Switch,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";

import { withRouter } from "react-router-dom";

import TemplateForm from "./Forms/template";
import ContentWrapper from "../../../template/Layout/ContentWrapper";

const { confirm } = Modal;

const theme = createTheme({
  components: {
    MuiSwitch: {
      styleOverrides: {
        // checked: {
        // Controls checked color for the thumb
        thumb: {
          // Controls default (unchecked) color for the thumb

          backgroundColor: "#fff",
        },
        // },

        track: {
          // Controls default (unchecked) color for the track
          opacity: 0.2,
          backgroundColor: "#9d9d9c",
          ".Mui-checked.Mui-checked + &": {
            // Controls checked color for the track
            opacity: 0.7,
            backgroundColor: "#0060a8",
          },
        },
      },
    },
  },
});

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000",
  },
  oblDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});
class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobil: false,
      data: {},
      tableEntityConf: [
        // { label: "ID", key: "EntityId" },
        { label: "ID", key: "EntityId" },
        { label: this.props.t("customer_name"), key: "Name" },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "Country" },
      ],
      TemplateForm,
      isEdit: false,
      createFormData: "",
      generalInfo: "",
      idUsuario: this.props.match ? this.props.match.params.id : -1,
      userInfo: {
        ConfirmPassword: "",
        Email: "",
        LastName: "",
        Name: "",
        Password: "",
        Position: "",
        Telephone: "",
      },
      unEditedInfo: {},
      selectCatalog: [],
      camposUsuario: true,
      camposValidos: false,
      guardarDisabled: true,
      confirmPassError: false,
      loadingInfo: true,
      isEditing: false,
      tablaClientes: "",
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice,
    });
    // this.getRoles();
    // this.getUser();
    await this.getCatalogs();
    if (this.state.idUsuario > 0) {
      this.getUser();
    } else {
      this.setState({ loadingInfo: false }, () => {
        this.renderForm(false);
      });
    }
  };
  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        // this.getRoles();
        // this.getUser();
      },
    );
  };

  handleChangeDrop = (attribute, isEdit) => (evt, data) => {
    let { userInfo, showClientes, guardarDisabled } = this.state;

    let campo = data ? data.value : null;
    userInfo[attribute] = campo;
    /**
     * 1	"Admin"
        2	"Europartners"
        3	"Europartners SU"
        4	"Cliente"
     */
    if (attribute === "RoleId" && data && data.value) {
      userInfo.Entities = [];
      if ([1, 2, 4].indexOf(data.value) >= 0) {
        showClientes = false;
      } else {
        showClientes = true;
      }
      guardarDisabled = !this.validarCampos(isEdit);
      //  else if (newSelected.length <= 0 && flatNext) {
      //   flatNext = false;
      // }
    } else if (attribute === "Reportes") {
      if (data && data.length > 0) {
        userInfo[attribute] = data.map((value) => {
          return value.value;
        });
      } else {
        userInfo[attribute] = [];
      }
    }

    this.setState({ userInfo, showClientes, guardarDisabled }, () => {
      this.renderForm(isEdit);
    });
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value != null && value !== "";
  };

  handleChangeFilter =
    (campo, isEdit) => (nextTargetKeys, direction, moveKeys) => {
      let { userInfo, guardarDisabled } = this.state;
      if (userInfo[campo]) {
        if (direction === "left") {
          moveKeys.forEach((key) => {
            var removeKey = userInfo[campo].indexOf(key);
            if (removeKey > -1) {
              userInfo[campo].splice(removeKey, 1);
            }
          });
          this.sendMessage(this.props.t("retired"), "info");
        } else {
          moveKeys.forEach((key) => {
            userInfo[campo].push(key);
          });
          this.sendMessage(this.props.t("added"), "info");
        }

        userInfo[campo] = userInfo[campo].filter(this.onlyUnique);
      } else {
        this.sendMessage(this.props.t("added"), "info");
        userInfo[campo] = moveKeys;
      }
      guardarDisabled = true;
      if (
        [1, 2, 4].indexOf(userInfo["RoleId"]) >= 0 ||
        (userInfo[campo] && userInfo[campo].length > 0)
      ) {
        guardarDisabled = false;
      }

      this.setState({ userInfo, guardarDisabled });
    };

  // sendMessage = (text, type) => {
  //   var messageClass = "";
  //   if (type === "error") {
  //     messageClass = "general-custom-ant-message error-custom-ant-message";
  //   } else if (type === "success") {
  //     messageClass = "general-custom-ant-message success-custom-ant-message";
  //   } else if (type === "info") {
  //     messageClass = "info-custom-ant-message";
  //   }
  //   message.open({
  //     content: text,
  //     className: messageClass,
  //   });
  // };

  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#085fb0",
      confirmButtonText: "Ok",
      html: `<div class="text-center">
      ${text}
      </div>`,
    });
  };

  editarInformacionAlta = () => {
    this.setState({ showClientes: false, camposUsuario: true }, () => {
      this.renderForm(false);
    });
  };

  getUser = async () => {
    let { userInfo, tablaClientes, unEditedInfo } = this.state;
    axios
      .get(
        `${Services.ADMIN.path}admin/getInfoUser/${this.state.idUsuario}`,
        {},
      )
      .then((response) => {
        userInfo = response.data.user[0];
        userInfo.Entities = this.parsearArrayInt(
          userInfo.EntitiesIds ? String(userInfo.EntitiesIds).split(",") : [],
        );
        userInfo.Reportes = this.parsearArrayInt(
          userInfo.ReportsIds ? userInfo.ReportsIds.split(",") : [],
        );

        userInfo.ReportsNames = this.obtenerNombreReportes(userInfo.Reportes);
        tablaClientes = this.obtenerTablaClientes(userInfo.Entities);
        unEditedInfo = _.cloneDeep(userInfo);
        userInfo.ConfirmPassword = "";
        userInfo.Password = "";
        this.setState(
          {
            userInfo,
            isEdit: true,
            tablaClientes,
            unEditedInfo,
            loadingInfo: false,
          },
          () => {
            this.renderForm(true);
            this.generarInfoGeneral();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  parsearArrayInt = (arr) => {
    let intArr = [];
    arr.forEach((s) => {
      intArr.push(parseInt(s));
    });
    return intArr;
  };

  obtenerTablaClientes = (EntitiesIds) => {
    var arrayEntity = [];

    let entitiesDB = this.state.selectCatalog["Entities"];
    entitiesDB.forEach((item) => {
      EntitiesIds.find((e) => {
        if (e === item.key) {
          arrayEntity.push(item.data);
        }
        return e === item.key;
      });
    });

    // EntitiesIds.map((entId) => {
    //   entitiesDB.map((catEnt) => {
    //     if (String(entId) == catEnt.key) {
    //       catEnt.data.dbid = entitiesDB.find((db) => {
    //         return db.data.EntityId == String(entId)
    //       })?.data.EntityId;
    //       arrayEntity.push(catEnt.data);
    //     }
    //   });
    // });

    // arrayEntity.sort((a, b) => b.Name - a.Name);
    // arrayEntity.sort(function (a, b) {
    //   if (a.Name > b.Name) {
    //     return 1;
    //   }
    //   if (a.Name < b.Name) {
    //     return -1;
    //   }
    //   // a must be equal to b
    //   return 0;
    // });
    return (
      <Table
        columns={this.state.tableEntityConf}
        data={arrayEntity}
        itemsByPage={5}
        rowClick={false}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };

  obtenerNombreReportes = (ReportsIds) => {
    let ReportsName = [];
    if (ReportsIds && ReportsIds.length > 0) {
      ReportsIds.forEach((id) => {
        this.state.selectCatalog["Reportes"].forEach((reporte) => {
          if (id === reporte.key) {
            // console.log("reporte", reporte);
            ReportsName.push(reporte.text);
          }
        });
      });
    }
    return ReportsName;
  };
  sortCatalogs = (array, attr) => {
    array.sort((a, b) => a[attr].localeCompare(b[attr]));
    return array;
  };

  sortEntityCatalogs = (array, attr) => {
    array.sort((a, b) => a.data[attr].localeCompare(b.data[attr]));
    return array;
  };
  getCatalogs = async () => {
    let { selectCatalog } = this.state;
    await axios
      .get(`${Services.ADMIN.path}admin/catalogs`, {})
      .then((response) => {
        selectCatalog["Reportes"] = this.sortCatalogs(
          response.data.reportes,
          "text",
        );
        selectCatalog["Roles"] = this.sortCatalogs(response.data.roles, "text");
        // selectCatalog["Entities"] = this.sortCatalogs(response.data.clientes, "text");
        selectCatalog["Entities"] = response.data.clientes;
        this.setState(
          {
            selectCatalog,
          },
          () => {
            this.renderForm();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  handleChange = (name, isEdit) => (event) => {
    let { userInfo, errorPass, confirmPassError, guardarDisabled } = this.state;
    let camposValidos;
    userInfo[name] = event.target.value;
    if (name === "Password" || name === "ConfirmPassword") {
      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/,
      );
      let pass = userInfo["Password"] ? userInfo["Password"] : "";
      if (emailRegex.test(pass)) {
        errorPass = false;
      } else {
        errorPass = true;
      }

      if (userInfo["ConfirmPassword"] !== userInfo["Password"]) {
        confirmPassError = true;
      } else {
        confirmPassError = false;
      }
      if (isEdit === true) {
        if (userInfo["ConfirmPassword"] === "" && userInfo["Password"] === "") {
          camposValidos = true;
          errorPass = false;
        } else {
          camposValidos = !confirmPassError && !errorPass;
        }
      } else {
        camposValidos = !confirmPassError && !errorPass;
      }
    }
    if (!confirmPassError && !errorPass) {
      camposValidos = this.validarCampos(isEdit);
    }
    //Habilitar guardado en edicion
    if (isEdit) {
      guardarDisabled = !camposValidos;
    }

    this.setState(
      { userInfo, errorPass, camposValidos, confirmPassError, guardarDisabled },
      () => this.renderForm(isEdit),
    );
  };

  validarCampos = (isEdit) => {
    let { userInfo } = this.state;
    var campos = TemplateForm[isEdit ? "editUser" : "createUser"];
    var valido = true;
    campos.forEach((campo) => {
      if (campo.required) {
        if (!userInfo[campo.id] || userInfo[campo.id] === "") {
          valido = false;
        }
      }
    });
    var flagEntities = false;
    if (isEdit) {
      if ([1, 2, 4].indexOf(userInfo.RoleId) >= 0) {
        flagEntities = true;
      } else {
        flagEntities = userInfo.Entities && userInfo.Entities.length > 0;
      }
    } else {
      flagEntities = true;
    }

    return valido && flagEntities;
  };

  handleActiveAlertsChange = (event, id, isEdit) => {
    let activeAlerts = event.target.checked;
    let { userInfo, guardarDisabled } = this.state;
    userInfo[id] = activeAlerts ? 1 : 0;
    guardarDisabled = !this.validarCampos(isEdit);
    this.setState({ userInfo, guardarDisabled }, () => {
      this.renderForm(isEdit);
    });
  };

  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };

    this.setState({
      dataReport,
    });
  };
  viewPass = (isEdit) => {
    let { viewpass, TemplateForm } = this.state;
    for (
      let i = 0;
      i < TemplateForm[isEdit ? "editUser" : "createUser"].length;
      i++
    ) {
      const e = TemplateForm[isEdit ? "editUser" : "createUser"][i];
      if (e.id === "ConfirmPassword" || e.id === "Password") {
        e.datatype = viewpass ? "" : "Password";
      }
    }
    this.setState({ TemplateForm }, () => {
      this.renderForm(isEdit);
    });
  };

  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  renderForm = (isEdit) => {
    let {
      TemplateForm,
      userInfo,
      selectCatalog,
      confirmPassError,
      showCatalogModal,
      viewpass,
      preview,
      errorPass,
    } = this.state;
    const { classes } = this.props;
    let createFormData = TemplateForm[isEdit ? "editUser" : "createUser"].map(
      (e) => {
        if (e.type === "Input")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  <label className={"title-custom-value"}>
                    {this.props.t(e.label)}{" "}
                    {e.required === true ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                </span>
              </Fade>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "3px",
                }}
              >
                <TextField
                  // label={e.placeHolder}
                  placeholder={this.props.t(e.placeHolder)}
                  title={this.props.t("fill_field")}
                  variant="standard"
                  type={e.datatype}
                  name={e.id}
                  value={userInfo[e.id]}
                  maxlength={e.maxlength}
                  minlength={e.minlength}
                  className={e.id === "Email" ? "email-lower" : ""}
                  InputProps={{
                    classes: {
                      input: "input-basic",
                    },
                  }}
                  onFocus={(e) => {
                    e.target.setAttribute("autocomplete", "none");
                  }}
                  onChange={this.handleChange(
                    e.id,
                    isEdit ? true : false,
                    e.validation,
                  )}
                  max={e.max}
                />

                {e.id === "ConfirmPassword" ? (
                  <em
                    className="mr-2 far fa-eye"
                    onClick={() =>
                      this.setState({ viewpass: !viewpass }, () =>
                        this.viewPass(isEdit),
                      )
                    }
                    style={{
                      color: "rgb(0, 121, 184)",
                      marginLeft: "10px",
                      fontSize: "20px",
                    }}
                    title={this.props.t("show_pass")}
                  ></em>
                ) : (
                  ""
                )}
              </div>
              {!preview && errorPass && e.id === "Password" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>
                      {this.props.t("pass_structure")}
                      <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
                        {this.props.t("extended_rule_pass")}
                      </p>
                    </label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                <li>At least one uppercase and one lowercase letter.</li>
                                <li>A special character(*$%&?_-)</li>
                            </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
              {!preview && confirmPassError && e.id === "ConfirmPassword" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>{this.props.t("password_not_match")}</label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                <li>At least one uppercase and one lowercase letter.</li>
                                <li>A special character(*$%&?_-)</li>
                            </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        else if (e.type === "Switch")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  <label className={"title-custom-value"}>
                    {this.props.t(e.label)}{" "}
                    {e.required === true ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                </span>
              </Fade>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "3px",
                }}
              >
                <ThemeProvider theme={theme}>
                  <Switch
                    checked={Number(userInfo[e.id])}
                    onChange={(event) =>
                      this.handleActiveAlertsChange(
                        event,
                        e.id,
                        isEdit ? true : false,
                      )
                    }
                  ></Switch>
                </ThemeProvider>
              </div>
            </div>
          );
        else if (e.type === "Select") {
          let defaultval = selectCatalog[e.selectCatalogName]
            ? selectCatalog[e.selectCatalogName].find((cat) => {
                return cat.value === userInfo[e.id];
              })
            : {};

          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={e.id} style={e.style}>
                  {" "}
                  <label className={"title-custom-value"}>
                    {this.props.t(e.label)}{" "}
                    {e.required ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}{" "}
                  </label>
                </span>
              </Fade>
              <Autocomplete
                closeText={false}
                openText={false}
                style={{ marginTop: "6px" }}
                id="size-small-standard"
                className="search-drops"
                size="small"
                value={defaultval}
                defaultValue={defaultval}
                isOptionEqualToValue={(a, b) => {
                  return a.value === b.value;
                }}
                ListboxProps={{
                  sx: {
                    fontSize: 12,
                    color: "#000",
                  },
                }}
                sx={{
                  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                    fontSize: 12,
                    color: "#000",
                  },
                }}
                options={
                  selectCatalog[e.selectCatalogName]
                    ? selectCatalog[e.selectCatalogName]
                    : []
                }
                getOptionLabel={(option) => option.text}
                onChange={this.handleChangeDrop(e.id, isEdit)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    className={classes.textfield}
                  />
                )}
              />

              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        } else
          return (
            <div
              className={e.class}
              style={{ marginTop: "20px" }}
              key={e.id}
            ></div>
          );
      },
    );
    this.setState({
      createFormData,
      showCatalogModal,
      userInfo,
      isEdit,
    });
  };
  generarInfoGeneral = () => {
    let { userInfo, isEdit, showClientes } = this.state;

    let generalInfo = TemplateForm["previewForm"].map((e) => {
      var attrInfo = "";
      var extraClass = "";

      if (e.type === "label") {
        let value = userInfo[e.id];
        if (e.id === "ActiveAlerts") {
          value =
            userInfo[e.id] !== "0" ? this.props.t("yes") : this.props.t("no");
        }
        attrInfo = <span className="tag-custom-value">{value}</span>;
      } else if (e.type === "list") {
        // attrInfo = <ul>
        //     {userInfo[e.id].map(element => {
        //         return <li>{element}</li>
        //     })}
        // </ul>
        attrInfo = (
          <span className="tag-custom-value">{userInfo[e.id].length}</span>
        );
        extraClass = "";
      } else if (e.type === "select") {
        if (userInfo[e.id]) {
          let catalog = this.state.selectCatalog[e.selectCatalogName];

          var value = catalog.filter((cat) => cat.key === userInfo[e.id]);

          attrInfo = <span className="tag-custom-value">{value[0].text}</span>;
        }
      } else if (e.type === "password") {
        if (this.state.isEdit) {
          return null;
        }
        attrInfo = <span className="tag-custom-value">***********</span>;
      }
      return (
        <div className={e.class} style={{ paddingTop: "1%" }}>
          {
            <div className="row">
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                <span className="title-custom-value">
                  {this.props.t(e.label)}
                </span>
              </div>
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                {attrInfo}
              </div>
            </div>
          }
        </div>
      );
    });

    if (!isEdit) {
      showClientes = true;
    }
    var guardarDisabled = true;
    if ([1, 2, 4].indexOf(userInfo["RoleId"]) >= 0) {
      guardarDisabled = false;
      showClientes = false;
    } else if (userInfo.Entities && userInfo.Entities.length > 0) {
      guardarDisabled = false;
    }
    this.setState({
      camposUsuario: false,
      showClientes,
      guardarDisabled,
      generalInfo,
    });
  };

  confirmaGuardado = async () => {
    let { isEdit } = this.state;
    var mensaje = this.props.t("sure_create_user");
    if (isEdit) {
      mensaje = this.props.t("sure_edit_user");
    }
    confirm({
      title: <hr className="hr-popover" style={{ margin: "0" }}></hr>,
      icon: false,
      cancelText: "No",
      okText: this.props.t("yes"),
      content: (
        <div>
          <div className="col-12" style={{ textAlign: "center" }}>
            <p class="seacargo-pop-icon">
              <em class="fas fa-exclamation-triangle"></em>
            </p>
            <span>{mensaje}</span>
          </div>
        </div>
      ),
      onOk: () => {
        this.setState({ loadingInfo: true }, () => {
          if (isEdit) {
            this.PutUser();
          } else {
            this.saveUser();
          }
        });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  saveUser = async () => {
    let { userInfo, selectCatalog } = this.state;
    userInfo["Email"] = userInfo["Email"].toLowerCase();

    let data = { data: userInfo };
    /**
         1-Admin
         2-SeaCargo SU
       */
    let entitiesArr = [];
    if ([1, 2].indexOf(data.data["RoleId"]) < 0) {
      data.data.Entities.forEach((entity) => {
        let entidad = selectCatalog["Entities"].find((ent) => {
          return entity.EntityId
            ? entity.EntityId === ent.key
            : entity === ent.key;
        });
        entitiesArr.push(entidad.value);
      });
    }
    data.data.Entities = entitiesArr;
    await axios
      .post(`${Services.ADMIN.path}admin/createUser`, data)
      .then((response) => {
        this.setState({ loadingInfo: false }, () => {
          this.sendMessage(this.props.t("user_save_success"), "success");
          this.sleep(1000).then(() => {
            this.props.history.push("/admin");
          });
        });
      })
      .catch((error) => {
        let userId = error.response.data.user;
        this.setState({ loadingInfo: false }, () => {
          if (error.response.data.code === "user_deleted") {
            confirm({
              title: <hr className="hr-popover"></hr>,
              icon: false,
              cancelText: "No",
              okText: this.props.t("yes"),
              content: (
                <div>
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <p class="seacargo-pop-icon">
                      <em class="fas fa-exclamation-triangle"></em>
                    </p>
                    <span> {this.props.t("email_activate_answer")}</span>
                  </div>
                </div>
              ),
              onOk: async () => {
                this.setState({ loadingInfo: true }, async () => {
                  await axios
                    .put(`${Services.ADMIN.path}admin/activateUser`, {
                      data: { UserId: userId },
                    })
                    .then(async (response) => {
                      this.setState({ loadingInfo: false }, () => {
                        Swal.fire({
                          icon: "success",
                          confirmButtonText: "Ok",
                          html: `<div class="text-center">
                          ${this.props.t("user_updated_successfully")}
                          </div>`,
                        }).then(async (result) => {
                          this.props.history.push(`/altausuario/${userId}`);
                          window.location.reload();
                        });
                      });
                    })
                    .catch((error) => {
                      this.sendMessage(
                        this.props.t(error.response.data.message),
                        "error",
                      );
                    });
                });
              },
              onCancel: async () => {
                this.props.history.push(`/admin`);
              },
            });
          } else if (error.response.data.code === "email_exist") {
            Swal.fire({
              icon: "info",
              confirmButtonText: "Ok",
              html: `<div class="text-center">
              ${this.props.t("email_in_use")}
              </div>`,
            }).then(async (result) => {
              this.props.history.push(`/altausuario/${userId}`);
              window.location.reload();
            });
          } else {
            this.sendMessage(
              this.props.t(
                error.response.data.message.replace(
                  "Required fields:",
                  this.props.t("required_fields") + ": ",
                ),
              ),
              "error",
            );
          }
        });
      });
  };

  cambiaEdicion = () => {
    let { showClientes } = this.state;
    if ([1, 2].indexOf(this.state.userInfo.RoleId) >= 0) {
      showClientes = false;
    } else {
      showClientes = true;
    }
    this.setState(
      {
        isEditing: true,
        camposUsuario: true,
        showClientes,
        guardarDisabled: false,
      },
      () => {
        this.renderForm(true);
      },
    );
  };

  cancelarEdicion = () => {
    let { unEditedInfo } = this.state;
    this.setState(
      {
        userInfo: _.cloneDeep(unEditedInfo),
        isEditing: false,
        camposUsuario: false,
        showClientes: false,
      },
      () => {
        this.generarInfoGeneral();
      },
    );
  };

  PutUser = async () => {
    let { userInfo, selectCatalog } = this.state;
    userInfo["Email"] = userInfo["Email"].toLowerCase();

    let data = { data: userInfo };
    /**
         1-Admin
         3-Euro SU
       */

    let entitiesArr = [];
    if ([1, 2, 4].indexOf(data.data["RoleId"]) < 0) {
      data.data.Entities.forEach((entity) => {
        let entidad = selectCatalog["Entities"].find((ent) => {
          return entity.EntityId
            ? entity.EntityId === ent.key
            : entity === ent.key;
        });
        entitiesArr.push(entidad.value);
      });
    }
    data.data.Entities = entitiesArr;

    await axios
      .put(`${Services.ADMIN.path}admin/updateUser`, data)
      .then((response) => {
        this.setState({ loadingInfo: false }, () => {
          this.sendMessage(this.props.t("user_update_success"), "success");
          this.sleep(1000).then(() => {
            this.props.history.push("/admin");
          });
        });
      })
      .catch((error) => {
        this.setState({ loadingInfo: false }, () => {
          this.sendMessage(
            this.props.t(
              error.response.data.data.message.replace(
                "Required fields:",
                this.props.t("required_fields") + ": ",
              ),
            ),
            "error",
          );
        });
      });
  };

  validateSaveUser = (e) => (evt) => {
    let validation = [];
    let errors = [];
    let Forms = TemplateForm.createUser;

    Forms.map((e) => {
      if (e.required === true) {
        validation.push(e);
      }
      return e;
    });
    validation.forEach((e) => {
      if (!this.state.userInfo[e.id] || this.state.userInfo[e.id] === "") {
        errors.push(this.props.t(e.label));
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "black";
      }
    });
    if (errors.length > 0) {
      message.error({
        content:
          this.props.t("required_fields") + ": " + errors.join(", ") + "",
      });
    } else {
      if (!this.state.confirmPassError) {
        this.generarInfoGeneral();
      } else {
        message.error({
          content: this.props.t("password_not_equal"),
        });
      }
    }
  };
  filterOption = (a, b, c) => {
    return b.label.toLowerCase().indexOf(a.toLowerCase()) > -1;
  };

  getValuesReports = () => {
    let { userInfo } = this.state;
    let arrayValues = [];
    this.state.selectCatalog["Reportes"].forEach((cat) => {
      userInfo["Reportes"].forEach((reporte) => {
        if (cat.value === reporte) {
          arrayValues.push(cat);
        }
      });
    });
    return arrayValues;
  };

  render() {
    let { showClientes, loadingInfo, isEditing, isEdit } = this.state;

    const { classes } = this.props;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <legend
            className="legendBasic basic-icon-module-tittle "
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <img
              style={{ width: "27px", marginRight: "5px" }}
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_usuario.svg">

            </img> */}
            <i className="demo-icon icon-final-19"></i>
            {this.props.t("admin_users")}
          </legend>
          <div className="_btnBack d-flex align-items-center">
            <Icon.Group>
              <Icon
                name="angle left"
                onClick={() => this.props.history.push("/admin")}
              />
            </Icon.Group>
            <span
              className="_text_btn-back"
              onClick={() => this.props.history.push("/admin")}
            >
              {this.props.t("back")}
            </span>
          </div>
        </div>
        <Row>
          <Col xs={12}>
            <Card className="myCard">
              <CardBody>
                <div className="row">
                  <div className="col-12">
                    <h4
                      className="basic-title-form"
                      style={{ fontSize: "16px" }}
                    >
                      {this.props.t("users")}
                    </h4>
                    <div>
                      <hr className="hr-basic-blue"></hr>
                    </div>
                  </div>
                </div>
                <div style={{ height: "20px" }} className="col-12"></div>
                <div className="col-12 pb-5">
                  {this.state.camposUsuario ? (
                    <div>
                      <h4 className="basic-title-form">
                        {" "}
                        {isEdit
                          ? this.props.t("user_edition")
                          : this.props.t("new_user")}
                      </h4>
                      <div className="row">{this.state.createFormData}</div>
                    </div>
                  ) : (
                    <div>
                      <div className="row">
                        <div className="col-8 row">
                          <h4 className="basic-title-form">
                            {this.state.isEdit
                              ? this.props.t("user_detail")
                              : this.props.t("user_information")}
                          </h4>
                        </div>
                        <div className="col-4">
                          {isEdit && !isEditing ? (
                            <em
                              style={{ fontSize: "25px", marginRight: "10px" }}
                              className="fas fa-pencil-alt clickable float-right"
                              onClick={() => this.cambiaEdicion()}
                              title={this.props.t("edit")}
                            ></em>
                          ) : (
                            false
                          )}
                        </div>
                      </div>

                      <div className="row">{this.state.generalInfo}</div>
                    </div>
                  )}
                  {this.state.isEdit ? (
                    <div style={{ marginTop: "50px", marginBottom: "25px" }}>
                      <h4 className="basic-title-form">
                        {this.props.t("assigned_reports")}
                      </h4>
                    </div>
                  ) : (
                    false
                  )}
                  <div className="row">
                    <div className="col-xs-12 col-md-4 col-lg4">
                      {isEdit && !isEditing ? (
                        <div className="row">
                          <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                            <span className={"title-custom-value"}>
                              {this.props.t("report")}
                            </span>
                          </div>
                          <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                            {this.state.userInfo.ReportsIds
                              ? this.state.userInfo.ReportsNames.join(", ")
                              : ""}
                          </div>
                        </div>
                      ) : isEdit ? (
                        <div className="input-form">
                          <Fade left opposite>
                            <label className={"title-custom-value"}>
                              {this.props.t("report")}{" "}
                            </label>
                          </Fade>
                          <Autocomplete
                            closeText={false}
                            openText={false}
                            multiple={true}
                            style={{ marginTop: "6px" }}
                            id="size-small-standard"
                            className="search-drops"
                            size="small"
                            ListboxProps={{
                              sx: { fontSize: 12 },
                            }}
                            sx={{
                              "& .MuiAutocomplete-input, & .MuiInputLabel-root":
                                {
                                  fontSize: 12,
                                },
                            }}
                            options={
                              this.state.selectCatalog["Reportes"]
                                ? this.state.selectCatalog["Reportes"]
                                : []
                            }
                            getOptionLabel={(option) => option.text}
                            onChange={this.handleChangeDrop(
                              "Reportes",
                              this.state.isEdit,
                            )}
                            defaultValue={
                              this.state.userInfo["Reportes"]
                                ? this.getValuesReports()
                                : []
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                className={classes.textfield}
                              />
                            )}
                          />
                        </div>
                      ) : (
                        false
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="col-12" style={{ marginTop: "15px", marginBottom: "15px" }}> */}
                <div className="col-xs-12 col-md-12 col-lg-12 row d-flex justify-content-end">
                  {!isEdit ? (
                    this.state.camposUsuario ? (
                      <>
                        <div className="col-xs-12 col-md-3 col-lg-2 pb-1">
                          <Button
                            block
                            variant="contained"
                            color="primary"
                            // className="button float-right"
                            onClick={this.validateSaveUser()}
                          >
                            {this.props.t("next")}
                          </Button>
                        </div>
                        <div className="col-xs-12 col-md-3 col-lg-2 pb-1">
                          <Button
                            block
                            variant="contained"
                            style={{
                              backgroundColor: "red",
                              marginRight: "10px",
                            }}
                            color="secondary"
                            // className="button float-right"
                            onClick={() => this.props.history.push("/admin")}
                          >
                            {this.props.t("cancel")}
                          </Button>
                        </div>
                      </>
                    ) : (
                      false
                    )
                  ) : (
                    false
                  )}
                </div>

                <div className="col-12" style={{ marginTop: "5%" }}>
                  {showClientes &&
                  (!this.state.camposUsuario || (isEdit && isEditing)) ? (
                    <>
                      <div style={{ marginTop: "50px", marginBottom: "25px" }}>
                        <h4 className="basic-title-form">
                          {this.state.isEdit
                            ? this.props.t("associate_customers")
                            : this.props.t("associate_customers")}
                        </h4>
                        <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
                          {this.props.t("at_least_customer")} *
                        </p>
                      </div>
                      <Transfer
                        style={{
                          marginTop: "25px",
                          width: "100%",
                          maxWidth: "100%",
                          justifyContent: "center",
                          height: "350px",
                        }}
                        locale={{
                          itemUnit: this.props.t("customer"),
                          itemsUnit: this.props.t("customers"),
                          searchPlaceholder: "",
                        }}
                        dataSource={this.state.selectCatalog["Entities"]}
                        showSearch
                        filterOption={this.filterOption}
                        onChange={this.handleChangeFilter(
                          "Entities",
                          this.state.isEdit,
                        )}
                        render={(item) => this.props.t(item.label)}
                        targetKeys={this.state.userInfo["Entities"]}
                        operations={[
                          this.props.t("associate"),
                          this.props.t("eliminate"),
                        ]}
                        // showSelectAll={false}
                      />
                    </>
                  ) : (
                    <div></div>
                  )}
                </div>
                {(!this.state.camposUsuario && !isEdit) ||
                (isEdit && isEditing) ? (
                  <div
                    className="col-12 row d-flex justify-content-end pt-3"
                    // style={{ marginTop: "15px", marginBottom: "15px" }}
                  >
                    {!this.state.isMobil ? (
                      <Button
                        style={{ marginRight: "10px" }}
                        variant="contained"
                        disabled={this.state.guardarDisabled}
                        color="primary"
                        className="button float-right"
                        onClick={() => this.confirmaGuardado()}
                      >
                        {this.props.t("save")}
                      </Button>
                    ) : (
                      <div className="col-xs-6 pr-1">
                        <Button
                          block
                          variant="contained"
                          disabled={this.state.guardarDisabled}
                          color="primary"
                          className="button float-right"
                          onClick={() => this.confirmaGuardado()}
                        >
                          {this.props.t("save")}
                        </Button>
                      </div>
                    )}

                    {isEdit && isEditing ? (
                      !this.state.isMobil ? (
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#085fb0",
                          }}
                          color="secondary"
                          className="button float-right"
                          onClick={() => {
                            this.cancelarEdicion();
                          }}
                        >
                          {this.props.t("cancel")}
                        </Button>
                      ) : (
                        <div className="col-xs-6">
                          <Button
                            block
                            variant="contained"
                            style={{
                              backgroundColor: "#085fb0",
                            }}
                            color="secondary"
                            className="button float-right"
                            onClick={() => {
                              this.cancelarEdicion();
                            }}
                          >
                            {this.props.t("cancel")}
                          </Button>
                        </div>
                      )
                    ) : (
                      false
                    )}
                    {!isEdit ? (
                      <Button
                        variant="contained"
                        // disabled={
                        //   !this.state.siguienteEnabled ? this.state.newSelected.length <= 0 : false
                        // }
                        style={{
                          backgroundColor: "#085fb0",
                          opacity: "80%",
                        }}
                        color="secondary"
                        className="button float-right"
                        onClick={() => {
                          this.editarInformacionAlta();
                        }}
                      >
                        {this.props.t("back")}
                      </Button>
                    ) : (
                      false
                    )}
                  </div>
                ) : (
                  <></>
                )}
                {isEdit && !isEditing ? (
                  <div className="">
                    <div className="col-12">{this.state.tablaClientes}</div>
                  </div>
                ) : (
                  false
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ContentWrapper>
    );
  }
}

export default withNamespaces()(withRouter(withStyles(useStyles)(createUsers)));
